import { SimpleModalId } from 'constants/modalId';
import { DeleteUserModalContentContainer } from './DeleteUserModalContentContainer';
import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';

export const DeleteUserModal = makeGuardedModal(SimpleModalId.DeleteUser, DeleteUserModalContentContainer);
